import * as React from 'react';

import type { LocationWindow } from 'types';

type Props = {
  location: LocationWindow
};

const withConsumerInsightsAuthentication = () =>
  (ChildComponent: React.ComponentType<any>) => {
    class WrappedComponent extends React.Component<Props> {
      render(): React.ReactNode {
        return (
          <ChildComponent {...this.props} />
        );
      }
    }

    return WrappedComponent;
  };

export default withConsumerInsightsAuthentication;
